import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportColumnPayload } from '../types';
import {
  ADD_REPORT_COLUMN_API_URL,
  ADD_REPORT_COLUMN_MUTATION,
  ROLES_PERMISSIONS,
} from '../constants';

export default function useAddReportColumnMutation(): IContextMutationResult<
  void,
  Error,
  IReportColumnPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IReportColumnPayload>({
    mutationKey: [ADD_REPORT_COLUMN_MUTATION],
    mutationFn: (payload) => fetchPost<void>(
      ADD_REPORT_COLUMN_API_URL,
      { report_field: payload },
      { permission: ROLES_PERMISSIONS.REPORT_FIELDS },
    ),
  });
}
